import { httpClient } from '@/services/http/httpClient'

type Params = { ideaId: string; newAuthorId: string }

export async function changeIdeaAuthor({ ideaId, newAuthorId }: Params) {
  await httpClient.put(`/ideas/ideas/${ideaId}/author`, {
    newAuthorId,
  })
}
